/* eslint-disable react/require-default-props */
import React, { Dispatch, ReactElement, SetStateAction, useState } from 'react'

import { CloseOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  PageHeader,
  Radio,
  Result,
  Row,
  Select,
  Typography,
} from 'antd'
import ID_COMPONENTE from 'config/idComponente'
import { IArmazem } from 'Models/docas'
import moment from 'moment'
import WsDocasService from 'Services/WS_DOCAS'

interface IProps {
  armazemSelecionado?: IArmazem
  dataSelecionada: moment.Moment
  setTela: Dispatch<SetStateAction<string>>
}

const BloqueioAgenda = ({
  armazemSelecionado,
  dataSelecionada,
  setTela,
}: IProps): ReactElement => {
  const { RangePicker } = DatePicker
  const [result, setResult] = useState<number>(0)
  const [resultError, setResultError] = useState<string>('')
  const [tipoBloqueio, setTipoBloqueio] = useState<number>(1)
  const { Paragraph } = Typography
  const { Option } = Select

  const disabledDates = (current: moment.Moment) => {
    const inPast = moment().diff(current, 'days') > 0
    const tooEarly = current.diff(moment().add(10, 'days'), 'days') >= 0
    return inPast || tooEarly
  }

  const handleSubmitBloquearAgenda = async (values: any) => {
    if (armazemSelecionado && armazemSelecionado.cdAgendamentoDocasArmazem) {
      let result

      const ini: moment.Moment = values.data[0]
      const fim: moment.Moment = values.data[1]

      if (tipoBloqueio === 1) {
        //Armazém
        result = await WsDocasService.agenda.bloqueiaAgendaByArmazem(
          ID_COMPONENTE.DOCAS,
          moment(
            ini.subtract(3, 'hours').format('YYYY-MM-DD HH:mm') + ':00',
          ).format('YYYY-MM-DD HH:mm:ss'),
          moment(
            fim.subtract(3, 'hours').format('YYYY-MM-DD HH:mm') + ':59',
          ).format('YYYY-MM-DD HH:mm:ss'),
          armazemSelecionado.cdAgendamentoDocasArmazem,
        )
      } else if (tipoBloqueio === 2) {
        //Janelas
        result = await WsDocasService.agenda.bloqueiaAgendaByJanela(
          ID_COMPONENTE.DOCAS,
          ini.format('YYYY-MM-DD') + ' 00:00:00',
          fim.format('YYYY-MM-DD') + ' 23:59:59',
          values.janela,
        )
      } else {
        result = await WsDocasService.agenda.bloqueiaAgendaByDoca(
          ID_COMPONENTE.DOCAS,
          moment(
            ini.subtract(3, 'hours').format('YYYY-MM-DD HH:mm') + ':00',
          ).format('YYYY-MM-DD HH:mm:ss'),
          moment(
            fim.subtract(3, 'hours').format('YYYY-MM-DD HH:mm') + ':59',
          ).format('YYYY-MM-DD HH:mm:ss'),
          values.doca,
        )
      }

      if (!result?.data.error) {
        setResult(200)
      } else {
        setResult(400)
        if (result?.data.message) {
          setResultError(result.data.message)
        }
      }
    } else {
      console.log('Armazém não selecionado')
    }
  }

  return (
    <>
      <PageHeader
        ghost={false}
        title="Bloquear Agenda"
        subTitle={armazemSelecionado?.nomeArmazem}
        extra={[
          <Button key="1" type="text" onClick={() => setTela('')}>
            <CloseOutlined />
          </Button>,
        ]}
      />
      {result === 0 ? (
        <Form
          layout="vertical"
          initialValues={{
            tipoBloqueio: 1,
            data: dataSelecionada,
            armazem: armazemSelecionado?.cdAgendamentoDocasArmazem,
          }}
          onFinish={handleSubmitBloquearAgenda}
        >
          <Row>
            <Paragraph>
              O bloqueio de agendas bloqueia um período inteiro de agendamento
              fazendo com que todos os horários fiquem indisponíveis.
            </Paragraph>
          </Row>
          <Row>
            <Col>
              <Form.Item
                name="tipoBloqueio"
                label="Bloquear por:"
                rules={[
                  {
                    required: true,
                    message: 'Campo obrigatório!',
                  },
                ]}
              >
                <Radio.Group
                  onChange={(e) => setTipoBloqueio(e.target.value)}
                  value={tipoBloqueio}
                >
                  <Radio value={1}>Armazém</Radio>
                  <Radio value={2}>Janela</Radio>
                  <Radio value={3}>Doca</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          {tipoBloqueio === 1 && (
            <>
              <Paragraph>
                <b>Armazém: </b>
                {armazemSelecionado?.nomeArmazem}
              </Paragraph>
              <Row align="middle">
                <Col>
                  <Form.Item
                    name="data"
                    label="Intervalo:"
                    rules={[
                      {
                        required: true,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                  >
                    <RangePicker
                      showTime
                      format={'DD/MM/YYYY HH:mm'}
                      disabledDate={disabledDates}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          {tipoBloqueio === 2 && (
            <>
              <Row>
                <Col>
                  <Form.Item
                    name="janela"
                    label="Janela:"
                    rules={[
                      {
                        required: true,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                  >
                    <Select style={{ width: 120 }}>
                      {armazemSelecionado?.agendamentoDocasJanelas.map(
                        (janela, index) => (
                          <Option
                            value={janela.cdAgendamentoDocasJanela}
                            key={index}
                          >
                            {janela.nomeJanela}
                          </Option>
                        ),
                      )}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row align="middle">
                <Col>
                  <Form.Item
                    name="data"
                    label="Intervalo:"
                    rules={[
                      {
                        required: true,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                  >
                    <RangePicker
                      format={'DD/MM/YYYY'}
                      disabledDate={disabledDates}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          {tipoBloqueio === 3 && (
            <>
              <Row>
                <Col>
                  <Form.Item
                    name="doca"
                    label="Doca:"
                    rules={[
                      {
                        required: true,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                  >
                    <Select style={{ width: 120 }}>
                      {armazemSelecionado?.agendamentoDocasDocas.map(
                        (doca, index) => (
                          <Option
                            value={doca.cdAgendamentoDocasDocas}
                            key={index}
                          >
                            {doca.nomeDoca}
                          </Option>
                        ),
                      )}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row align="middle">
                <Col>
                  <Form.Item
                    name="data"
                    label="Intervalo:"
                    rules={[
                      {
                        required: true,
                        message: 'Campo obrigatório!',
                      },
                    ]}
                  >
                    <RangePicker
                      showTime
                      format={'DD/MM/YYYY HH:mm'}
                      disabledDate={disabledDates}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          <Row align="middle">
            <Col>
              <Button type="primary" htmlType="submit">
                Bloquear agenda
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <>
          {result === 200 ? (
            <Result
              status="success"
              title="Agenda bloqueada com sucesso!"
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => setResult(0)}
                >
                  Bloquear outra data
                </Button>,
              ]}
            />
          ) : null}

          {result !== 200 ? (
            <Result
              status="error"
              title="Não foi possível bloquear a agenda selecionada"
              subTitle={resultError}
              extra={[
                <Button
                  type="primary"
                  key="console"
                  onClick={() => setResult(0)}
                >
                  Tentar novamente
                </Button>,
              ]}
            />
          ) : null}
        </>
      )}
    </>
  )
}

export default BloqueioAgenda
